module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app large"
  }, [_c('div', {
    attrs: {
      "id": "loadingAjax"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleData.title || '...')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "article-header-info"
  }, [_c('span', {
    staticClass: "article-header-info-date"
  }, [_vm._v("\n            " + _vm._s(_vm.articleData.formatted_date || '...') + "\n            " + _vm._s((_vm.articleData.categories || []).includes(798) ? "|" : "") + "\n            " + _vm._s((_vm.articleData.categories || []).includes(798) ? ("By " + (_vm.articleData.customs.author_of_the_feature)) : "") + "\n        ")]), _vm._v(" "), _c('tags', {
    attrs: {
      "categories": _vm.articleData.categories || []
    }
  })], 1), _vm._v(" "), (_vm.articleData.content) ? _c('main', [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('intrinsic', {
    attrs: {
      "small": _vm.articleData.media[_vm.thumbnail].url,
      "floatRatio": _vm.articleData.media[_vm.thumbnail].height / _vm.articleData.media[_vm.thumbnail].width,
      "alt": _vm.articleData.media[_vm.thumbnail].alt
    }
  }), _vm._v(" "), (_vm.articleData.media[_vm.thumbnail].alt) ? _c('span', {
    staticClass: "image-alt"
  }, [_vm._v("\n                " + _vm._s(_vm.articleData.media[_vm.thumbnail].alt) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "image-data"
  }, [(_vm.articleData && _vm.articleData.customs && _vm.articleData.customs.author_of_the_feature) ? _c('span', {
    staticClass: "feature-author"
  }, [_vm._v("\n                Author: " + _vm._s(_vm.articleData.customs.author_of_the_feature) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "article-header-info-date"
  }, [_vm._v("\n                " + _vm._s(_vm.articleData.formatted_date || '...') + "\n            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('social'), _vm._v(" "), _c('article-content', {
    attrs: {
      "namingIsHard": _vm.articleData.content
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('donate-banner'), _vm._v(" "), _c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("\n            Read More\n        ")]), _vm._v(" "), _c('readmore', {
    attrs: {
      "features": false,
      "rows": 2,
      "thumbnail_size": "medium",
      "currentArticle": _vm.articleData.id
    }
  })], 1) : _c('main', [_c('loading')], 1), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('lazy-component', [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("\n                Features\n            ")]), _vm._v(" "), _c('readmore', {
    key: _vm.articleData.id,
    attrs: {
      "news": false,
      "currentArticle": _vm.articleData.id,
      "columns": 4,
      "amount": 24
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('lazy-component', {
    on: {
      "show": function($event) {
        _vm.openPage(1)
      }
    }
  }, [_c('our-articles', {
    attrs: {
      "articles": _vm.articles,
      "loading": _vm.loading,
      "nextPage": _vm.nextPage,
      "finished": _vm.finished
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f17028c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/article-js.vue
// module id = 184
// module chunks = 4